"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _framerMotion = require("framer-motion");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _excluded = ["isShown", "variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var hotspotSize = {
  "default": {
    padding: 4,
    size: 10,
    effectSize: 20,
    borderSize: 2
  },
  small: {
    padding: 2,
    size: 4,
    effectSize: 10,
    borderSize: 1
  }
};
var HBHotspot = function HBHotspot(_ref) {
  var isShown = _ref.isShown,
    variant = _ref.variant,
    position = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!isShown) {
    return null;
  }
  var _hotspotSize$variant = hotspotSize[variant],
    padding = _hotspotSize$variant.padding,
    size = _hotspotSize$variant.size,
    effectSize = _hotspotSize$variant.effectSize,
    borderSize = _hotspotSize$variant.borderSize;
  return /*#__PURE__*/_react["default"].createElement(HotspotPeripheral, {
    "data-testid": "hotspot",
    $padding: padding,
    style: _objectSpread({}, position)
  }, /*#__PURE__*/_react["default"].createElement(Hotspot, {
    $size: size
  }, /*#__PURE__*/_react["default"].createElement(HotspotEffect, {
    $borderSize: borderSize,
    $effectSize: effectSize
  })));
};
var HotspotPeripheral = _styledComponents["default"].div.withConfig({
  displayName: "HBHotspot__HotspotPeripheral",
  componentId: "sc-1g9rpae-0"
})(["position:relative;border-radius:50%;background:", ";padding:", "px;z-index:2;"], _colors["default"].transparent, function (props) {
  return props.$padding;
});
var Hotspot = _styledComponents["default"].div.withConfig({
  displayName: "HBHotspot__Hotspot",
  componentId: "sc-1g9rpae-1"
})(["position:relative;display:flex;justify-content:center;align-items:center;width:", "px;height:", "px;background:", ";border-radius:50%;"], function (props) {
  return props.$size;
}, function (props) {
  return props.$size;
}, _colors["default"].purple500);
var HotspotEffect = (0, _styledComponents["default"])(_framerMotion.motion.div).attrs({
  animate: {
    opacity: [1, 0.6, 0],
    scale: [0.5, 1.5]
  },
  transition: {
    duration: 1.5,
    ease: 'easeOut',
    repeat: Infinity
  }
}).withConfig({
  displayName: "HBHotspot__HotspotEffect",
  componentId: "sc-1g9rpae-2"
})(["position:absolute;height:", "px;width:", "px;border-radius:50%;border:", "px solid ", ";"], function (props) {
  return props.$effectSize;
}, function (props) {
  return props.$effectSize;
}, function (props) {
  return props.$borderSize;
}, _colors["default"].purple500);
var _default = exports["default"] = HBHotspot;
//# sourceMappingURL=HBHotspot.js.map